var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBxRepost(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 65,
    viewBox: "0 0 64 65",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M50.6673 19.1667C50.6673 17.692 49.4753 16.5 48.0007 16.5H26.6673V21.8333H45.334V35.1667H37.334L47.918 48.5L58.6673 35.1667H50.6673V19.1667ZM13.334 45.8333C13.334 47.308 14.526 48.5 16.0007 48.5H37.334V43.1667H18.6673V29.8333H26.6673L16.0007 16.5L5.33398 29.8333H13.334V45.8333Z",
    fill: "#666666"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBxRepost);
export default __webpack_public_path__ + "static/media/bx-repost.0d2c1ad97cc869aa89fd5d9fb3e1bd3d.svg";
export { ForwardRef as ReactComponent };